import React, { useEffect, useState } from "react";
import TopNav from "../components/common/topnav.component";
import { Carousel } from 'primereact/carousel';
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useDispatch, useSelector } from "react-redux";
import {
    fetchAt_A_Glance_Top_Tile
} from '../redux/slices/counter';
import { useLocation } from "react-router-dom";
import Cookies from 'js-cookie'

/******Main Fact ******/
import Assessment_icon from '../assets/images/assessment_icon.png'
import Attendance_icon from '../assets/images/attendance_icon.png'
import Graduation_icon from '../assets/images/graduation_icon.png'
import District_Ranking_icon from '../assets/images/District_Ranking_icon.png'
import Student_Behavior_icon from '../assets/images/Student_Behavior_icon.png'
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';
import TreadingarrowDown from "../assets/images/treading-arrow-down.png"
import TreadingarrowUp from '../assets/images/treading-arrow-up.png';
import Enrollment from "./dashboardtiles/enrollment.component";
import StudentCharacteristics from "./dashboardtiles/studentcharacteristics.component";
import SchoolDistrictEmployees from "./dashboardtiles/schooldistrictemployees.component";
import SchoolsCenters from "./dashboardtiles/schoolscenters.component";
import FinancialInformation from "./dashboardtiles/financialiInformation.component";
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { number } from "echarts";
import { Tooltip } from 'primereact/tooltip';
import ValueTooltip from "../components/Tooltip/valueTooltip";
import { format, getMetricDisplayValue } from "../utils";


export default function Dashboard(props) {
    const location = useLocation();
    const dispatch = useDispatch();
    const At_A_Glance_Top_Tiledata = useSelector(state => state.netsales.At_A_Glance_Top_Tile);
    const At_A_Glance_Top_Tileloading = useSelector(state => state.netsales.At_A_Glance_Top_Tileloading)
    const queryParams = new URLSearchParams(location.search);

    // authentication code

    // const setCookieWithExpiration = (name, value) => {
    //     Cookies.set(name, value, { expires: 1 / 24 });
    // };

    // useEffect(() => {
    //     setCookieWithExpiration("username", queryParams.get('username'))
    //     if (Cookies.get('username') === "JohnDoe") {

    //     } else {
    //         window.location.href = "https://sfpsdashboardui-wckqd7o3eq-uw.a.run.app/"
    //     }

    // }, [Cookies])




    useEffect(() => {
        dispatch(fetchAt_A_Glance_Top_Tile({
            "elasticQueryName": "At_A_Glance_Top_Tile",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }, {
                "columnName": "SCHOOL_OFFICIAL_NAME",
                "columnValue": ["DistrictWide"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
    }, [])
    // const [mainFacts, setMainFacts] = useState(dataset);
    const [mainDashboard, setMainDashboard] = useState([]);

    const timeAnalysis = (data, key, maxCategories = 2) => {
        if (data && data.length) {
            let newMetric = [];
            let dataset = [];

            data.forEach(obj => {
                if (newMetric.indexOf(obj[key]) === -1) {
                    let index = 0;
                    let categories = [];
                    data.forEach(row => {
                        if (obj[key] === row[key]) {
                            categories.push({
                                percentage: row["PERCENTAGE"] === number ? row["PERCENTAGE"]?.toFixed(1) : row["PERCENTAGE"],

                                label: row["METRIC_NAME"],
                                variance: row["VARIANCE"],
                                py_variance: row["VARIANCE_PY2"],
                                py_Var: row["PY_PERCENTAGE"]?.toFixed(1),
                                py_Var2: row["PY2_PERCENTAGE"]?.toFixed(1),
                                indicator: row["METRIC_INDICATOR_TYPE"],
                                description: row["METRIC_DESCRIPTION"],
                                numeric_value: row["NUMERIC_VALUE"],
                                metric_type: row?.["METRIC_TYPE"]

                            });
                        }
                    });
                    while (categories.length > 0) {
                        let new_obj = { ...obj };
                        let chunk = categories.splice(0, maxCategories);

                        chunk.forEach((cat, idx) => {
                            new_obj[`category_${idx + 1}`] = cat.percentage;
                            new_obj[`category_label_${idx + 1}`] = cat.label;
                            new_obj[`variance_${idx + 1}`] = cat.variance;
                            new_obj[`py_variance_${idx + 1}`] = cat.py_variance;
                            new_obj[`category_PyVar_${idx + 1}`] = cat.py_Var;
                            new_obj[`category_PyVar2_${idx + 1}`] = cat.py_Var2;
                            new_obj[`description_${idx + 1}`] = cat.description;
                            new_obj[`indicator${idx + 1}`] = cat.indicator;
                            new_obj[`metric_type_${idx + 1}`] = cat.metric_type;
                            new_obj[`numeric_value_${idx + 1}`] = cat.numeric_value;

                        });

                        dataset.push(new_obj);
                    }

                    newMetric.push(obj[key]);
                }
            });

            return dataset;
        }
        return [];
    };

    function combineMetrics(data) {
        // Helper function to prefix keys
        function prefixKeys(obj, prefix) {
            let newObj = {};
            for (let key in obj) {
                newObj[`${prefix}${key}`] = obj[key];
            }
            return newObj;
        }

        // Define the transformed data array
        let transformedData = [];

        // Iterate through the input data
        data.forEach(metric => {
            if (metric.METRIC_GROUP === "ELA Assessment") {
                // Check if we already have an Assessment group object in transformedData
                let assessmentGroup = transformedData.find(item => item.METRIC_GROUP === "Assessment");
                if (!assessmentGroup) {
                    assessmentGroup = { METRIC_GROUP: "Assessment" };
                    transformedData.push(assessmentGroup);
                }
                Object.assign(assessmentGroup, prefixKeys(metric, 'ela_'));
            } else if (metric.METRIC_GROUP === "Math Assessment") {
                // Check if we already have an Assessment group object in transformedData
                let assessmentGroup = transformedData.find(item => item.METRIC_GROUP === "Assessment");
                if (!assessmentGroup) {
                    assessmentGroup = { METRIC_GROUP: "Assessment" };
                    transformedData.push(assessmentGroup);
                }
                Object.assign(assessmentGroup, prefixKeys(metric, 'math_'));
            } else {
                transformedData.push(metric);
            }
        });

        return transformedData;
    }
    var alertnew = JSON.parse(JSON.stringify(combineMetrics(At_A_Glance_Top_Tiledata)));
    let aaa = alertnew?.filter(itr => itr["METRIC_NAME"] != "% of SPED - NWEA")
    let bbb = alertnew?.filter(itr => itr["METRIC_NAME"] == "% of SPED - NWEA")

    let dataset = timeAnalysis(aaa, "METRIC_GROUP");
    let dataset1 = timeAnalysis(bbb, "METRIC_NAME");

    dataset?.map(itr => {
        if (itr["METRIC_GROUP"] == "Attendance") {
            itr["img"] = "Attendance_icon"
        }
        if (itr["METRIC_GROUP"] == "Student Behavior") {
            itr["img"] = "Student_Behavior_icon"
        }
        if (itr["METRIC_GROUP"] == "ELA Assessment") {
            itr["img"] = "Assessment_icon"
        }
        if (itr["METRIC_GROUP"] == "Assessment") {
            itr["img"] = "Assessment_icon"
        }
        if (itr["METRIC_GROUP"] == "Math Assessment") {
            itr["img"] = "Assessment_icon"
        }
    })

    let datasetnew;
    if (dataset1?.length > 0) {
        datasetnew = dataset?.concat(dataset1);
    } else {
        datasetnew = dataset;
    }

    datasetnew?.map(itr => {
        if (itr["METRIC_GROUP"] == "Enrollment") {
            itr["ORDER"] = 5
        }
        if (itr["METRIC_GROUP"] == "Attendance") {
            itr["ORDER"] = 1
        }
        if (itr["METRIC_GROUP"] == "Student Behavior") {
            itr["ORDER"] = 2
        }
        if (itr["METRIC_GROUP"] == "Assessment") {
            itr["ORDER"] = 3
        }
        if (itr["METRIC_GROUP"] == "Science Assessment") {
            itr["ORDER"] = 4
        }
        if (itr["METRIC_GROUP"] == "ELA Assessment" && itr["METRIC_ID"] == 10092) {
            itr["ORDER"] = 6
        }
        if (itr["METRIC_GROUP"] == "ELA Assessment" && itr["METRIC_ID"] == 10093 || itr["METRIC_ID"] == 10096) {
            itr["ORDER"] = 7
        }
        if (itr["METRIC_GROUP"] == "Math Assessment") {
            itr["ORDER"] = 8
        }
        if (itr["METRIC_GROUP"] == "Assessment - STAAR") {
            itr["ORDER"] = 9
        }
        if (itr["METRIC_GROUP"] == "Reading Assessment - STAAR") {
            itr["ORDER"] = 10
        }
        if (itr["METRIC_GROUP"] == "STAAR Assessment") {
            itr["ORDER"] = 11
        }
        if (itr["METRIC_GROUP"] == "Math Assessment - STAAR") {
            itr["ORDER"] = 111
        }
    })


    if (datasetnew) {
        datasetnew = datasetnew.slice().sort((a, b) => {
            return a.ORDER - b.ORDER
        })
    }


    /********Main Fact **********/
    const responsiveOptions = [
        {
            breakpoint: '1199px',
            numVisible: 3,
            numScroll: 3
        },
        {
            breakpoint: '1366px',
            numVisible: 4,
            numScroll: 4
        },
        {
            breakpoint: '1600px',
            numVisible: 5,
            numScroll: 4
        },
        {
            breakpoint: '991px',
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: '767px',
            numVisible: 1,
            numScroll: 1
        }
    ];
    /********Main Fact end **********/

    /********main Dashboard**********/
    const mainDashboardservice = {
        getmainDashboardData() {
            return [
                {
                    "silder": <Enrollment />
                },
                {
                    "silder": <StudentCharacteristics />
                }
                ,
                {
                    "silder": <SchoolDistrictEmployees />
                }
                ,
                {
                    "silder": <SchoolsCenters />
                }
                ,
                {
                    "silder": <FinancialInformation />
                }
            ];
        },

        getmainDashboardSmall() {
            return Promise.resolve(this.getmainDashboardData().slice(0, 10));
        },

    };
    /******** mainDashboard end **********/

    useEffect(() => {
        // mainFactservice.getmainFactsSmall().then((data) => setMainFacts(dataset));
        mainDashboardservice.getmainDashboardSmall().then((data) => setMainDashboard(data.slice(0, 9)));

    }, []);

    const TooltipAttributes = ({ categoryLabel, schoolYear, category_Name }) => {
        return {
            'data-pr-tooltip': `Variance from Last Year ${category_Name?.startsWith('College') ? categoryLabel?.toLocaleString() : categoryLabel + "%"}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            // 'data-pr-className': 'custom-tooltip',
            style: { fontSize: '0rem', cursor: 'pointer' }
        }
    }

    const TooltipAttributes1 = ({ categorydescription, schoolYear }) => {
        return {
            'data-pr-tooltip': `${categorydescription}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            // 'data-pr-className': 'custom-tooltip',
            style: { fontSize: '0rem', cursor: 'pointer' }
        }
    }

    function VarianceBGColor(metric_type, curr_year, prev_year, metric_grp, variance) {
        if (metric_grp == "Student Behavior") {
            if (variance > 0) {
                return 'trendingdown'
            }
            else {
                return 'trendingup'
            }
        }
        if (metric_type == 'negative') {
            if (curr_year < prev_year) {
                return 'trendingup';
            }
            else {
                return 'trendingdown';
            }
        } else {
            if (curr_year < prev_year) {
                return 'trendingdown'
            }
            else {
                return 'trendingup'
            }
        }
    }

    const MainFactsTemplate = (mainFacts) => {

        return (
            <>

                <div className="product-item">
                    <div className="mnfcts-carimg product-item-content bg-[#0F0D0B] rounded-[6px] min-h-[125px]" style={{ marginRight: "10px" }}>
                        <div className="bg-[#272321]">
                            <div className="p-2 flex gap-5">
                                <div >
                                    {
                                        mainFacts?.METRIC_GROUP == "Attendance" ? <img src={Attendance_icon} alt='' className="w-[40px] h-[42px]" /> :
                                            mainFacts?.METRIC_GROUP == "Student Behavior" ? <img src={Student_Behavior_icon} alt='' className="w-[40px] h-[42px]" /> :
                                                mainFacts?.METRIC_GROUP == "Graduation" ? <img src={Graduation_icon} alt='' className="w-[40px] h-[42px]" /> :
                                                    //    <img src={mainFacts?.img} alt='' className="w-[40px] h-[42px]" />
                                                    <img src={Assessment_icon} alt='' className="w-[40px] h-[42px]" />


                                    }
                                    {/* // <img src={mainFacts?.img} alt='' className="w-[40px] h-[42px]" /> */}
                                </div>
                                <div className="w-full">
                                    <p className="text-[14.2px] text-[#fff] " style={{ top: "5px", position: "relative", fontSize: "15.2px", }}>{mainFacts?.METRIC_GROUP == "Assessment" && mainFacts?.category_label_1 == "M-STEP Assessment(Grade 3-12)-Math Proficiency Rate" ? "Assessment - M-STEP" : mainFacts?.METRIC_GROUP == "Assessment" && mainFacts?.category_label_1 == "College Board Assessment(Grade 2 & 4)- PSAT" ? "Assessment - College Board" : mainFacts?.METRIC_GROUP != "Enrollment" ? mainFacts?.METRIC_GROUP : "Graduation"}</p>
                                    {(mainFacts?.category_1 === 0) && <p
                                        className="text-[12px] text-[#fff] items-center whitespace-nowrap overflow-hidden text-ellipsis"
                                        style={{
                                            top: "4px",
                                            position: "relative",
                                            maxWidth: "200px",
                                            fontSize: "12px",
                                        }}
                                        title={`(Spring ${mainFacts?.SCHOOL_YEAR - 1} from SY: ${mainFacts?.SCHOOL_YEAR - 2
                                            }-${String(mainFacts?.SCHOOL_YEAR - 1).slice(-2)})`}
                                    >
                                        {`(Spring ${mainFacts?.SCHOOL_YEAR - 1} from SY: ${mainFacts?.SCHOOL_YEAR - 2
                                            }-${String(mainFacts?.SCHOOL_YEAR - 1).slice(-2)})`}
                                    </p>}
                                    {/* {(mainFacts?.category_label_1 == "College Board (SAT)" || mainFacts?.category_label_2 == "College Board (PSAT)") && <p className="text-[12px] text-[#fff] items-center" style={{ top: "12px", position: "relative", fontSize: "12px", }}>{`(SY: ${mainFacts?.SCHOOL_YEAR - 1}-${mainFacts?.SCHOOL_YEAR})`}</p>} */}
                                    {/* <p className="text-[12px] text-[#fff] " style={{top: "10px",position: "relative",fontSize: "15px",}}>Graduation</p> */}
                                    {/* <h2 className="text-[18px] text-[#fff]">{mainFacts.title}</h2> */}
                                </div>
                            </div>

                        </div>
                        <div className="bg-[#0F0D0B]">
                            <div className="flex justify-between px-2 2xl:px-3 gap-2 mt-2 h-[70px] py-0">
                                <Tooltip target=".custom-target-icon" />
                                {
                                    mainFacts?.category_label_1 != "# of Graduates" ?
                                        <div className={` space-y-2 ${mainFacts?.METRIC_GROUP == "Attendance" ? "col-span-6 max-h-[70px] overflow-hidden cursor-pointer" : "col-span-6 max-h-[70px] overflow-hidden cursor-pointer"}`}
                                        >
                                            <div className="flex custom-target-icon  desc_minheight max-w-[110px]" {...TooltipAttributes1({ categorydescription: mainFacts?.description_1, schoolYear: mainFacts?.SCHOOL_YEAR })}>
                                                <p className="text-[12px] text-[#fff] truncate"> {mainFacts?.category_label_1}</p>
                                            </div>
                                            {/* {mainFacts?.category_1 === 0 ? <p  className="text-[9.2px] text-[#fff] whitespace-nowrap">(Latest School Year:2023-2024)</p> : ''} */}
                                            {
                                                (() => {
                                                    let displayValue_1 = getMetricDisplayValue(mainFacts?.category_1, mainFacts?.category_PyVar_1, mainFacts?.METRIC_GROUP);
                                                    let metric_value_1 = format(displayValue_1, { suffix: mainFacts?.metric_type_1?.toLowerCase() === 'percentage' ? '%' : '', forcedecimals: mainFacts?.metric_type_1?.toLowerCase() === 'percentage' ? 1 : 0 });

                                                    if (mainFacts?.METRIC_GROUP == "Attendance") {
                                                        return (
                                                            <div className="flex custom-target-icon items-center">
                                                                <ValueTooltip targetClass={'custom-valueTooltip'} heading={mainFacts?.category_label_1} value1={metric_value_1} value2={mainFacts?.numeric_value_1}>
                                                                    <p className="text-[12px] 2xl:text-[16px] text-[#fff] font-semibold">
                                                                        {metric_value_1}
                                                                    </p>
                                                                </ValueTooltip>
                                                                <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: Number(mainFacts?.category_1) ? mainFacts?.category_PyVar_1 : mainFacts?.category_PyVar2_1, schoolYear: mainFacts?.SCHOOL_YEAR, category_Name: mainFacts?.category_label_1 })}>
                                                                    <p className="text-[10px] 2xl:text-[12px] text-[#fff] font-semibold ml-2 mt-0.5">
                                                                        {/* <div className={`h-4 ${mainFacts?.category_label_2 == 'Chronic Absenteeism' || mainFacts?.METRIC_GROUP == "Student Behavior" ? (Number(mainFacts?.variance_1) < 0 ? 'trendingup' : 'trendingdown') : (Number(mainFacts?.variance_1) < 0 ? 'trendingdown' : 'trendingup')}`}> */}
                                                                        <div className={`h-4 ${VarianceBGColor(mainFacts?.indicator1, mainFacts?.category_1, Number(mainFacts?.category_PyVar_1), mainFacts?.METRIC_GROUP, Number(mainFacts?.category_1) ? mainFacts?.variance_1 : mainFacts?.py_variance_1)}`}>

                                                                            <img src={(Number(mainFacts?.category_1) ? Number(mainFacts?.variance_1) : Number(mainFacts?.py_variance_1)) < 0 ? TreadingarrowDown : TreadingarrowUp} className="" />
                                                                            {Number(mainFacts?.category_1) ? (Number(mainFacts?.variance_1) ? Number(mainFacts?.variance_1)?.toFixed(1) : "-") : (Number(mainFacts?.py_variance_1) ? Number(mainFacts?.py_variance_1)?.toFixed(1) : "-")}%
                                                                        </div>
                                                                    </p>
                                                                </div>

                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className="flex custom-target-icon items-center">
                                                                <ValueTooltip targetClass={'custom-valueTooltip1'} heading={mainFacts?.category_label_1} value1={metric_value_1} value2={mainFacts?.category_label_1?.startsWith('College') ? mainFacts?.numeric_value_1?.toFixed(1) + '%' : mainFacts?.numeric_value_1}>
                                                                    <p className="text-[12px] 2xl:text-[16px] text-[#fff] font-semibold whitespace-nowrap">
                                                                        {metric_value_1}
                                                                    </p>
                                                                </ValueTooltip>
                                                                <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: Number(mainFacts?.category_1) ? mainFacts?.category_PyVar_1 : mainFacts?.category_PyVar2_1, schoolYear: mainFacts?.SCHOOL_YEAR, category_Name: mainFacts?.category_label_1 })}>
                                                                    <p className="text-[9px] 2xl:text-[11px] text-[#fff] font-semibold ml-1 2xl:ml-2 mt-0.5">
                                                                        <div className={`h-4 ${VarianceBGColor(mainFacts?.indicator1, mainFacts?.category_1, Number(mainFacts?.category_PyVar_1), mainFacts?.METRIC_GROUP, Number(mainFacts?.category_1) ? mainFacts?.variance_1 : mainFacts?.py_variance_1)}`}>
                                                                            <img src={(Number(mainFacts?.category_1) ? Number(mainFacts?.variance_1) : Number(mainFacts?.py_variance_1)) < 0 ? TreadingarrowDown : TreadingarrowUp} className="" />
                                                                            {Number(mainFacts?.category_1) ? (Number(mainFacts?.variance_1) ? Number(mainFacts?.variance_1)?.toFixed(1) + "%" : "-") : (Number(mainFacts?.py_variance_1) ? Number(mainFacts?.py_variance_1)?.toFixed(1) + "%" : "-")}
                                                                        </div>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })()
                                            }


                                        </div> : null
                                }
                                <div className={`space-y-2 ${mainFacts?.METRIC_GROUP == "Attendance" ? "col-span-6 max-h-[70px] overflow-hidden" : "col-span-6 max-h-[70px] overflow-hidden"}`}>
                                    <div className="flex custom-target-icon desc_minheight max-w-[110px]" {...TooltipAttributes1({ categorydescription: mainFacts?.description_2, schoolYear: mainFacts?.SCHOOL_YEAR })}>
                                        <p className="text-[12px] text-[#fff] truncate "> {mainFacts?.METRIC_GROUP != "Enrollment" ? mainFacts?.category_label_2 : "Graduation Rate"}</p>
                                    </div>
                                    {
                                        (() => {
                                            let displayValue_2 = getMetricDisplayValue(mainFacts?.category_2, mainFacts?.category_PyVar_2, mainFacts?.METRIC_GROUP);
                                            let metric_value_2 = format(displayValue_2, { suffix: mainFacts?.metric_type_2?.toLowerCase() === 'percentage' ? '%' : '', forcedecimals: mainFacts?.metric_type_2?.toLowerCase() === 'percentage' ? 1 : 0 });

                                            if (mainFacts?.METRIC_GROUP !== "Enrollment") {
                                                if (mainFacts?.category_label_2 !== undefined) {
                                                    if (mainFacts?.METRIC_GROUP === "Attendance") {
                                                        return (
                                                            <div className="flex custom-target-icon items-center">
                                                                <ValueTooltip targetClass={'custom-valueTooltip'} heading={mainFacts?.category_label_2} value1={metric_value_2} value2={mainFacts?.numeric_value_2}>
                                                                    <p className="text-[12px] 2xl:text-[16px] text-[#fff] font-semibold">
                                                                        {metric_value_2}
                                                                    </p>
                                                                </ValueTooltip>
                                                                <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: Number(mainFacts?.category_2) ? mainFacts?.category_PyVar_2 : mainFacts?.category_PyVar2_2, schoolYear: mainFacts?.SCHOOL_YEAR, category_Name: mainFacts?.category_label_2 })}>
                                                                    <p className="text-[9px] 2xl:text-[11px] text-[#fff] font-semibold ml-1 2xl:ml-2 mt-0.5">
                                                                        {/* <div className={`h-4 ${(mainFacts?.category_label_2 == 'Chronic Absenteeism' || mainFacts?.METRIC_GROUP == "Student Behavior") ? (Number(mainFacts?.variance_2) < 0 ? 'trendingup' : 'trendingdown') : (Number(mainFacts?.variance_2) < 0 ? 'trendingdown' : 'trendingup')}`}> */}
                                                                        <div className={`h-4 ${VarianceBGColor(mainFacts?.indicator2, mainFacts?.category_2, Number(mainFacts?.category_PyVar_2), mainFacts?.METRIC_GROUP, Number(mainFacts?.category_2) ? mainFacts?.variance_2 : mainFacts?.py_variance_2)}`}>
                                                                            <img src={(Number(mainFacts?.category_2) ? Number(mainFacts?.variance_2) : Number(mainFacts?.py_variance_2)) < 0 ? TreadingarrowDown : TreadingarrowUp} className="" /> {Number(mainFacts?.category_2) ? (Number(mainFacts?.variance_2) ? Number(mainFacts?.variance_2)?.toFixed(1) + '%' : "-") : (Number(mainFacts?.py_variance_2) ? Number(mainFacts?.py_variance_2)?.toFixed(1) + '%' : "-")}
                                                                        </div>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        );
                                                    } else {
                                                        return (

                                                            <div className="flex custom-target-icon items-center">
                                                                <ValueTooltip targetClass={'custom-valueTooltip'} heading={mainFacts?.category_label_2} value1={metric_value_2} value2={mainFacts?.category_label_1?.startsWith('College') ? mainFacts?.numeric_value_2?.toFixed(1) + '%' : mainFacts?.numeric_value_2}>
                                                                    <p className="text-[12px] 2xl:text-[16px] text-[#fff] font-semibold whitespace-nowrap">
                                                                        {metric_value_2}
                                                                    </p>
                                                                </ValueTooltip>
                                                                <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: Number(mainFacts?.category_2) ? mainFacts?.category_PyVar_2 : mainFacts?.category_PyVar2_2, schoolYear: mainFacts?.SCHOOL_YEAR, category_Name: mainFacts?.category_label_2 })}>
                                                                    <p className="text-[10px] 2xl:text-[12px] text-[#fff] font-semibold ml-2 mt-0.5">
                                                                        {/* <div className={`h-4 ${(mainFacts?.category_label_2 == 'Chronic Absenteeism' || mainFacts?.METRIC_GROUP == "Student Behavior") ? (Number(mainFacts?.variance_2) < 0 ? 'trendingup' : 'trendingdown') : (Number(mainFacts?.variance_2) < 0 ? 'trendingdown' : 'trendingup')}`}> */}
                                                                        <div className={`h-4 ${VarianceBGColor(mainFacts?.indicator2, mainFacts?.category_2, Number(mainFacts?.category_PyVar_2), mainFacts?.METRIC_GROUP, Number(mainFacts?.category_2) ? mainFacts?.variance_2 : mainFacts?.py_variance_2)}`}>
                                                                            <img src={(Number(mainFacts?.category_2) ? Number(mainFacts?.variance_2) : Number(mainFacts?.py_variance_2)) < 0 ? TreadingarrowDown : TreadingarrowUp} className="" /> {Number(mainFacts?.category_2) ? (Number(mainFacts?.variance_2) ? Number(mainFacts?.variance_2)?.toFixed(1) + '%' : "-") : (Number(mainFacts?.py_variance_2) ? Number(mainFacts?.py_variance_2)?.toFixed(1) + '%' : "-")}
                                                                        </div>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                } else {
                                                    return null;
                                                }
                                            } else {
                                                return (
                                                    <div className="flex">
                                                        <p className="text-[12.2px] text-[#fff] font-semibold">
                                                            {metric_value_2}
                                                        </p>
                                                        <p className="text-[8.2px] text-[#fff] font-semibold ml-2 mt-0.5">
                                                            <div className={`h-4 ${mainFacts?.PY_PERCENTAGE < 0 ? 'trendingdown' : 'trendingup'}`}>
                                                                <img src={mainFacts?.PY_PERCENTAGE < 0 ? TreadingarrowDown : TreadingarrowUp} className="" /> {mainFacts?.PY_PERCENTAGE ? mainFacts?.PY_PERCENTAGE?.toFixed(1) : "-"}%
                                                            </div>
                                                        </p>
                                                    </div>
                                                );
                                            }
                                        })()
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    };

    return (
        <div className="pt-0 dashboard">
            <TopNav pagename="District at a Glance" pagenamedescription="Key Facts about the District" setUserData={props.setUserData} />
            <AppliedFilters pagename={"District at a Glance"} />
            <div className="mb-20 main-facts">

                <div className="mb-20 mx-[40px]">
                    <h6 className="text-[16.2px] text-[#fff] pt-2">Main Facts</h6>
                    <p className="text-[14.2px] text-[#fff]">The scorecard reflects the District's position in the key measurement areas</p>
                    <LoaderContainer height={"150px"} width={"100%"} loading={At_A_Glance_Top_Tileloading} className="mt-2 mb-5">
                        <div className="mt-2 mb-5">
                            {
                                datasetnew && <Carousel value={datasetnew} numVisible={5} numScroll={1} responsiveOptions={responsiveOptions} itemTemplate={MainFactsTemplate} />
                            }
                        </div>
                    </LoaderContainer>
                </div>
            </div>

            <div className="px-10 pb-10 mt-10">
                <div className="mt-10 dashboard-silder dash-slid-img relative">
                    <div className="swiper-button-prev custom-swiper-prev"></div>
                    <div className="swiper-button-next custom-swiper-next"></div>
                    <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={8}
                        slidesPerView={4}
                        navigation={{
                            nextEl: ".custom-swiper-next",
                            prevEl: ".custom-swiper-prev",
                        }}
                        breakpoints={{
                            500: { slidesPerView: 2 },
                            865: { slidesPerView: 3 },
                            1000: { slidesPerView: 3 },
                            1100: { slidesPerView: 4 },
                            1300: { slidesPerView: 4 },
                            1500: { slidesPerView: 4 },
                            1700: { slidesPerView: 4 },
                            2000: { slidesPerView: 4 }
                        }}
                        pagination={{ clickable: true }}
                    >
                        <SwiperSlide> <Enrollment /></SwiperSlide>
                        <SwiperSlide> <StudentCharacteristics /></SwiperSlide>
                        <SwiperSlide> <SchoolDistrictEmployees /></SwiperSlide>
                        <SwiperSlide> <SchoolsCenters /></SwiperSlide>
                        {/* <SwiperSlide> <FinancialInformation /></SwiperSlide> */}
                    </Swiper>
                </div>
            </div>
            <div className="py-4 flex justify-end">
                <div className="flex items-end">
                    <span className="text-white">Powered By </span>
                    <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                </div>
            </div>
        </div>
    )
}

export function formatCategoryValue(categoryValue, categoryLabel, pyCategoryValue) {
    if (categoryValue === 0) {
        if (categoryLabel == "College Board (SAT)" || categoryLabel == "College Board (PSAT)") return `${pyCategoryValue}`;
        return `${pyCategoryValue}%`;
    }

    if (!isNaN(categoryValue)) {
        if (categoryLabel?.endsWith("Rate")) {
            return `${categoryValue.toFixed(1)}%`;
        }
        if (categoryLabel?.startsWith('College')) {
            return `${categoryValue.toFixed(0)}`
        }
        return categoryValue.toFixed(1) + "%";
    }

    return '-';
}
